import { useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar, OptionsObject } from 'notistack';

import * as actions from '../store/snacks/snacksActions';
import useTypedSelector from './useTypedSelector';

export default function useNotifier() {
  const notistack = useSnackbar();
  const notifications = useTypedSelector(({ snacksState }) => {
    return snacksState.notifications;
  });
  const dispatch = useDispatch();
  const displayed = useRef<number[]>([]);

  const enqueueSnackbar = useCallback((message: string, options?: OptionsObject) => {
    notistack.enqueueSnackbar(message, options);
  }, [ notistack ]);

  const clearSnackbar = useCallback((key: number) => {
    dispatch( actions.clearSnackbar(key) );
  }, [ dispatch ]);

  useEffect(() => {
    for (const notification of notifications) {
      if (displayed.current.includes(notification.key)) {
        return;
      }
      enqueueSnackbar(notification.message, notification.options);
      displayed.current = [ ...displayed.current, notification.key ];
      clearSnackbar(notification.key);
    }
  }, [ notifications, enqueueSnackbar, clearSnackbar ]);
}
